import { render, staticRenderFns } from "./LikedContentView.vue?vue&type=template&id=b8ef5be8&scoped=true&"
import script from "./LikedContentView.vue?vue&type=script&lang=ts&"
export * from "./LikedContentView.vue?vue&type=script&lang=ts&"
import style0 from "./LikedContentView.vue?vue&type=style&index=0&id=b8ef5be8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ef5be8",
  null
  
)

export default component.exports